const STIPULATOR_BASE_ROUTE = '/estipulante/:nrSeqGrupoContratoWeb/contrato/:nrSeqContrato';
const LOGIN_BASE_ROUTE = '/login';

function mountRoute(route: string, prefix: string = STIPULATOR_BASE_ROUTE): string {
  return `${prefix}${route}`;
}

export const FOUNDATION_ROUTES = {
  ALTERAR_SENHA: mountRoute('/alterar-senha', LOGIN_BASE_ROUTE),
  CONFIRMAR_USUARIO_FALHA: '/falha-confirmar-usuario',
  CONFIRMAR_USUARIO_NOVA_SENHA: '/confirmar-usuario/:hash/nova-senha',
  CONFIRMAR_USUARIO: '/confirmar-usuario/:hash',
  FORGOT_PASSWORD: mountRoute('/redefinir-senha', LOGIN_BASE_ROUTE),
  HOME: '/estipulante',
  INACTIVITY: '/inatividade',
  LOGIN: mountRoute('', LOGIN_BASE_ROUTE),
  NEW_PASSWORD: '/nova-senha/:hash',
  RENOVAR_SENHA_BY_USERNAME: mountRoute('/renovar-senha/:username', LOGIN_BASE_ROUTE),
};

export const MODULE_ROUTES = {
  BENEFICIARIOS: mountRoute('/beneficiarios'),
};

export const APPLICATION_ROUTES = {
  ALTERACAO_BENEFICIARIO: mountRoute('/alterar-beneficiario'),
  ANALISE_ATENDIMENTOS: mountRoute('/analise-atendimentos'),
  DASHBOARD: mountRoute(''),
  DINAMICO: mountRoute('/dinamico'),
  DOSSIE_BENEFICIARIO: mountRoute('/dossie-beneficiario'),
  DOSSIE_CONTRATO: mountRoute('/contrato-dossie'),
  EXCLUSAO_BENEFICIARIO: mountRoute('/exclusao-beneficiario'),
  FOLHAS_PAGAMENTO: mountRoute('/folhas-pagamento'),
  FATURAS: mountRoute('/faturas'),
  HISTORICO_ANALISES: mountRoute('/historico-analises'),
  HISTORICO_AUTORIZACAO: mountRoute('/historicos-autorizacoes'),
  HISTORICO_REQUISICOES: mountRoute('/historicos-requisicoes'),
  HISTORICO_SOLICITACOES: mountRoute('/historico-solicitacoes'),
  INCLUSAO_BENEFICIARIO: '/inclusoes',
  INCONSISTENCIA_SIB: mountRoute('/inconsistencia-sib'),
  MENSALIDADES: mountRoute('/mensalidades'),
  MOVIMENTACAO_LOTE: mountRoute('/lotes'),
  REINCLUSAO_BENEFICIARIO: mountRoute('/reinclusao-beneficiario'),
  RELATORIOS: mountRoute('/relatorios'),
};

export const Route = {
  ALTERACAO_CADASTRO: mountRoute('/pessoa/:cdPessoaFisica/detalhes/:nrSeqBeneficiario/motivo/:nrSeqProtocolo'),
  ALTERACOES_VINCULO: `${APPLICATION_ROUTES.HISTORICO_SOLICITACOES}/alteracao-vinculo`,
  ALTERAR_ADMISSAO: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/:nrSeqBeneficiario/alterar-admissao`,
  ALTERAR_LOCALIZACAO: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/:nrSeqBeneficiario/alterar-localizacao`,
  ALTERAR_MATRICULA: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/:nrSeqBeneficiario/alterar-matricula`,
  ALTERAR_PRODUTO: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/:nrSeqBeneficiario/alterar-produto`,
  ALTERAR_SENHA: mountRoute('/meus-dados/alterar-senha'),
  ALTERAR_SUBESTIPULANTE: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/:nrSeqBeneficiario/alterar-subestipulante`,
  ALTERAR_VINCULO: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/:nrSeqBeneficiario/alterar-vinculo`,
  ASSIGN_AVISO_DE_PRIVACIDADE: mountRoute('/aviso-de-privacidade/:nrSeqAviso'),
  ASSIGN_TERMO_DE_USO: mountRoute('/termo-de-uso/:nrSeqTermo'),
  BENEF_DETALHE: `${APPLICATION_ROUTES.EXCLUSAO_BENEFICIARIO}/:nrSeqRescisao/solicitacao-rescisao/:ieSolicitacaoRescisao`,
  BENEF_NOVA_EXCLUSAO: `${APPLICATION_ROUTES.EXCLUSAO_BENEFICIARIO}/nova-exclusao`,
  BENEF_NOVA: '/nova',
  BENEF_REENVIAR_EXCLUSAO: `${APPLICATION_ROUTES.EXCLUSAO_BENEFICIARIO}/:nrSeqRescisao/solicitacao-rescisao/:ieSolicitacaoRescisao/reenviar-exclusao`,
  BENEF_SEQ_DETALHES: '/:nrSeqInclusao/detalhes',
  BENEF_SEQ_NOVA: '/:nrSeqInclusao/nova',
  BENEF_SEQ_REENVIAR: '/:nrSeqInclusao/reenviar',
  BENEFICIARY_DATA_DETALHES: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/:nrSeqBeneficiario/pessoa/:cdPessoaFisica/detalhes`,
  BENEFICIARY_DATA: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/:nrSeqBeneficiario/pessoa/:cdPessoaFisica`,
  CARTAO_CONFIRMAR: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/cartao/:nrSeqBeneficiario/confirmar`,
  CARTAO_CONSULTAR: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/cartao/:nrSeqBeneficiario/consultar`,
  CARTAO_SOLICITAR: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/cartao/:nrSeqBeneficiario/solicitar`,
  CONSULTA_ALTERAR_CADASTRO: `${APPLICATION_ROUTES.HISTORICO_SOLICITACOES}/alteracao-cadastral`,
  CONSULTA_ALTERAR_DATA_ADMIMISSAO: `${APPLICATION_ROUTES.HISTORICO_SOLICITACOES}/alteracao-data-admissao`,
  CONSULTA_ALTERAR_LOCALIZACAO: `${APPLICATION_ROUTES.HISTORICO_SOLICITACOES}/alteracao-localizacao`,
  CONSULTA_ALTERAR_MATRICULA: `${APPLICATION_ROUTES.HISTORICO_SOLICITACOES}/alteracao-matricula`,
  CONSULTA_ALTERAR_PRODUTO: `${APPLICATION_ROUTES.HISTORICO_SOLICITACOES}/alteracao-produto`,
  CONSULTA_ALTERAR_SUBESTIPULANTE: `${APPLICATION_ROUTES.HISTORICO_SOLICITACOES}/alteracao-subestipulante`,
  CONSULTA_ALTERAR_VINCULO: `${APPLICATION_ROUTES.HISTORICO_SOLICITACOES}/alteracao-vinculo`,
  CONSULTA_COMPARTILHAMENTO_RISCO: `${APPLICATION_ROUTES.HISTORICO_SOLICITACOES}/compartilhamento-risco`,
  CONSULTA_INCLUSAO_BENEFICIARIO: `${APPLICATION_ROUTES.HISTORICO_SOLICITACOES}/inclusao-beneficiario`,
  CONSULTA_MIGRAR_CONTRATO: `${APPLICATION_ROUTES.HISTORICO_SOLICITACOES}/migracao-contrato`,
  CONSULTA_STATUS_SEGUNDA_VIA: `${APPLICATION_ROUTES.HISTORICO_SOLICITACOES}/segunda-via`,
  CONSULTA_TRANSFERENCIA_TITULARIDADE: `${APPLICATION_ROUTES.HISTORICO_SOLICITACOES}/transferencia-titularidade`,
  DETALHES_BENEF_LOTE: `${APPLICATION_ROUTES.MOVIMENTACAO_LOTE}/:nrSeqLote/beneficiarios/:nrSeqInclusao`,
  FINALIZAR_REPASSE: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/:nrSeqBeneficiario/finalizar-repasse`,
  HISTORICO_ALT_CADASTRAL: `${APPLICATION_ROUTES.HISTORICO_SOLICITACOES}/:nrSeqSolicAlt/pessoas/:cdPessoaFisica`,
  HISTORICO_AUTORIZACAO: `${APPLICATION_ROUTES.HISTORICO_AUTORIZACAO}/:nrSeqGuia`,
  HISTORICO_REQUISICAO: `${APPLICATION_ROUTES.HISTORICO_REQUISICOES}/:nrSequencia`,
  HISTORICO_REQUISICAO_HISTORICO_AUTORIZACAO: `${APPLICATION_ROUTES.HISTORICO_REQUISICOES}/:nrSequencia/autorizacoes/:nrSeqGuia`,
  HISTORICO_SOLICITACOES_ATENDIMENTO_DETALHES: `${APPLICATION_ROUTES.HISTORICO_ANALISES}/:nrSeqAuditoria/detalhes`,
  INCLUIR_BENEF_LOTE: `${APPLICATION_ROUTES.MOVIMENTACAO_LOTE}/:nrSeqLote/incluir-beneficiario`,
  LOTE: `${APPLICATION_ROUTES.MOVIMENTACAO_LOTE}/:nrSeqLote`,
  MEUS_DADOS: mountRoute('/meus-dados'),
  MIGRAR_CONTRATO: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/:nrSeqBeneficiario/migracao-contrato`,
  PRIVACIDADE: mountRoute('/privacidade'),
  REINCLUIR_BENEFICIARIO_DETALHES: `${APPLICATION_ROUTES.REINCLUSAO_BENEFICIARIO}/:nrSeqBeneficiario`,
  RELATORIO_BENEFICIARIOS: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/relatorios`,
  SOLICITACOES_PENDENTES_DETALHES_AUTORIZACAO: `${APPLICATION_ROUTES.ANALISE_ATENDIMENTOS}/:nrSeqGuia/detalhes-autorizacao`,
  SOLICITACOES_PENDENTES_DETALHES_REQUISICAO: `${APPLICATION_ROUTES.ANALISE_ATENDIMENTOS}/:nrSeqAuditoria/detalhes-requisicao`,
  SOLICITAR_REPASSE: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/:nrSeqBeneficiario/solicitar-repasse`,
  TRANSFERIR_TITULARIDADE: `${APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO}/:nrSeqBeneficiario/transferir-titularidade`,
  MENSAGENS: mountRoute('/mensagens'),
  MENSAGEM_DETALHES: mountRoute('/mensagens/:nrSeqComunicado/detalhes'),
};

export const FULL_ROUTES = {
  BENEF_NOVA_INCLUSAO_CONSULTA: `${MODULE_ROUTES.BENEFICIARIOS}${APPLICATION_ROUTES.INCLUSAO_BENEFICIARIO}`,
  BENEF_NOVA_INCLUSAO: `${MODULE_ROUTES.BENEFICIARIOS}${APPLICATION_ROUTES.INCLUSAO_BENEFICIARIO}${Route.BENEF_NOVA}`,
  BENEF_SEQ_DETALHES: `${MODULE_ROUTES.BENEFICIARIOS}${APPLICATION_ROUTES.INCLUSAO_BENEFICIARIO}${Route.BENEF_SEQ_DETALHES}`,
  BENEF_SEQ_NOVA_INCLUSAO: `${MODULE_ROUTES.BENEFICIARIOS}${APPLICATION_ROUTES.INCLUSAO_BENEFICIARIO}${Route.BENEF_SEQ_NOVA}`,
  BENEF_SEQ_REENVIAR_INCLUSAO: `${MODULE_ROUTES.BENEFICIARIOS}${APPLICATION_ROUTES.INCLUSAO_BENEFICIARIO}${Route.BENEF_SEQ_REENVIAR}`,
};
